export default "__VITE_ASSET__CZiS4Q89__"